import React from "react";
import styles from "./DeeplinkSourcesList.module.css";
import { HubAnalyticsDeeplinkSource } from "../types";
import { formatInteger, formatPercent } from "../utils/formatNumber";

interface DeeplinkSourcesListProps {
    title: string;
    subtitle?: string;
    sources: HubAnalyticsDeeplinkSource[];
    conversionRate: number;
    /** i18n callout, e.g. "Taux de conversion global : 13,1%". */
    calloutLabel: string;
    clicksLabel: string;
    emptyLabel: string;
}

const DeeplinkSourcesList: React.FC<DeeplinkSourcesListProps> = ({
    title,
    subtitle,
    sources,
    conversionRate,
    calloutLabel,
    clicksLabel,
    emptyLabel,
}) => {
    const maxClicks = sources.reduce((acc, s) => (s.clicks > acc ? s.clicks : acc), 0) || 1;

    return (
        <section className={styles.card}>
            <header className={styles.header}>
                <h3 className={styles.title}>{title}</h3>
                {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
            </header>
            {sources.length === 0 ? (
                <p className={styles.empty}>{emptyLabel}</p>
            ) : (
                <ul className={styles.list}>
                    {sources.map((src) => {
                        const pct = (src.clicks / maxClicks) * 100;
                        return (
                            <li key={src.trackId} className={styles.row}>
                                <span className={styles.label}>{src.name}</span>
                                <span className={styles.value}>
                                    {formatInteger(src.clicks)} {clicksLabel}
                                </span>
                                <span className={styles.bar}>
                                    <span className={styles.barFill} style={{ width: `${pct}%` }} />
                                </span>
                            </li>
                        );
                    })}
                </ul>
            )}
            <p className={styles.callout}>
                {calloutLabel} <strong>{formatPercent(conversionRate, 1)}</strong>
            </p>
        </section>
    );
};

export default DeeplinkSourcesList;
